module.exports = __webpack_public_path__ + "img/DateTime.b3916516.svg";